import {lazy, Suspense} from 'react'
import {Logout} from '@mui/icons-material'
import {useRoutes} from 'react-router-dom'
import LoginPage from 'src/components/auth/LoginPage'
import ProtectedRoute from 'src/components/auth/ProtectedRoutes'
import AccessDenied from 'src/components/auth/AccessDenied'
import CuiLoading from 'src/components/custom/CuiLoading'

const Main = lazy(() => import('src/components/layout/Main'))
const InstitutionsPage = lazy(
  () => import('src/components/Institutions/InstitutionsPage')
)
const InstitutionsView = lazy(
  () => import('src/components/Institutions/InstitutionsView')
)
const Payments = lazy(() => import('src/components/PaymentsPage/Payments'))
const InstitutionalPayments = lazy(
  () => import('src/components/PaymentsPage/InstitutionalPayments')
)
const DatotRates = lazy(() => import('src/components/DatotRates'))
const MonthCalcSettings = lazy(
  () => import('src/components/MonthCalcSettings/MonthCalcSettings')
)
const AllStudentsPage = lazy(
  () => import('src/components/students/AllStudentsPage')
)
const EmailComposePage = lazy(
  () => import('src/components/email/EmailComposePage')
)
const EmailHistoryPage = lazy(
  () => import('src/components/email/EmailHistoryPage')
)
const UnapprovedReportsPage = lazy(
  () => import('src/components/reports/UnapprovedReportsPage')
)

const withSuspense = (node: JSX.Element) => (
  <Suspense fallback={<CuiLoading />}>{node}</Suspense>
)

export default function Router() {
  return useRoutes([
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/logout',
      element: <Logout />
    },
    {
      path: '/accessDenied',
      element: <AccessDenied />
    },
    {
      path: '/',
      element: <ProtectedRoute>{withSuspense(<Main />)}</ProtectedRoute>,
      children: [
        {
          path: '',
          element: withSuspense(<InstitutionsPage />)
        },
        {
          path: '/institutions',
          element: withSuspense(<InstitutionsPage />)
        },
        {
          path: '/institutions/:institutionId',
          element: withSuspense(<InstitutionsView />)
        },
        {
          path: '/payments',
          element: withSuspense(<Payments />)
        },
        {
          path: '/institutionalPayments',
          element: withSuspense(<InstitutionalPayments />)
        },
        {
          path: '/datotRates',
          element: withSuspense(<DatotRates />)
        },
        {
          path: '/monthCalcSettings',
          element: withSuspense(<MonthCalcSettings />)
        },
        {
          path: '/students',
          element: withSuspense(<AllStudentsPage />)
        },
        {
          path: '/sendEmail',
          element: withSuspense(<EmailComposePage />)
        },
        {
          path: '/emailHistory',
          element: withSuspense(<EmailHistoryPage />)
        },
        {
          path: '/unapprovedReports',
          element: withSuspense(<UnapprovedReportsPage />)
        }
      ]
    }
  ])
}
